var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgThreeDots = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 4,
  viewBox: "0 0 16 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 2C4 0.9 3.1 3.69671e-08 2 2.38498e-08C0.9 1.07324e-08 3.69671e-08 0.9 2.38498e-08 2C1.07324e-08 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2ZM6 2C6 3.1 6.9 4 8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 1.08516e-07 8 9.5399e-08C6.9 8.22817e-08 6 0.9 6 2ZM12 2C12 3.1 12.9 4 14 4C15.1 4 16 3.1 16 2C16 0.9 15.1 1.80066e-07 14 1.66948e-07C12.9 1.53831e-07 12 0.9 12 2Z",
  fill: "#546BD6"
})));
export { SvgThreeDots as ReactComponent };
export default __webpack_public_path__ + "a673a86e3edaa8653cf92f39886c7de8.svg";